module.exports = __webpack_public_path__ + "static/img/view5-1.d22fe0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view5-1.png
// module id = SjKk
// module chunks = 1